import { render, staticRenderFns } from "./EditChangePwd.vue?vue&type=template&id=b7d4889c&"
import script from "./EditChangePwd.vue?vue&type=script&lang=ts&"
export * from "./EditChangePwd.vue?vue&type=script&lang=ts&"
import style0 from "./EditChangePwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports